<template>
    <div style="background-color: #fff; ">
        <HeadBar :title="title" :bg="'transparent'"></HeadBar>
        <div style="height: 250px;background-color: #574AA5;margin: 0;position: relative;z-index: 99;">
			<div style="text-align: center; color: #fff;padding-top: 20px;">
				<span style="font-size: 12px;">总消费</span>
				<div style="font-size: 28px;padding-top: 10px;">{{zgfjine}}</div>
			   <!-- <div style="font-size: 13px;padding-top: 10px;">≈￥{{zgfjine}}</div> -->
				<div style="padding-top: 20px;">
					<van-button color="#574AA5" plain round style="height: 35px;" @click="show=true">点击购买</van-button>
				</div>
			</div>
		<div style="color: #fff;padding-right: 30px;text-align: right;padding-top: 18px;font-size: 13px;">已分红：{{zsfjine}}</div>
		</div>
		<div style="padding: 15px; background: #fff;border-radius:30px 30px 0px 0px;position:fixed; top:230px;left:0;bottom:0;right:0;z-index: 999;">
			<div style="text-align: center;border-bottom: 1px solid #f7f7f7;padding-bottom: 10px;font-size: 15px;">购买记录</div>
			<div style="padding-top: 10px;">
				<van-row style="text-align: center;font-size: 14px;color: #574AA5;font-weight: bold;">
					
					<van-col span="6">金额</van-col>
					<van-col span="6">已分红</van-col>
					<van-col span="12">状态</van-col>
					
				</van-row>
				<div style="padding-top: 10px;">
					<van-row v-for="(item,index) in list" :key="index" style="font-size: 14px;text-align: center;border-bottom: 1px dashed  #f7f7f7;padding: 10px;">
						<van-col span="6">{{item.gfjine}}</van-col>
						<van-col span="6">{{item.sfjine}}</van-col>
						
						<van-col span="12" style="display: flex;justify-content: end;align-items: center;">
						{{item.state == 0?'分红中':'结束'}}
						<van-button color="#EE8B83" plain  style="height: 19px;margin-left: 10px;" @click="tolink(item.id)">查看</van-button>
					
						</van-col>
					</van-row>
					<van-empty v-if="list.length ==0" description="暂无记录" />

				</div>
			</div>
		</div>
		
		<van-dialog v-model="show" title="购买股份" show-cancel-button @confirm="Buy">
			<div style="padding: 30px;">
				<div style="font-size: 13px;color: red">1股={{price}}积分</div>
				
				  <van-field v-model="num" label="数量" placeholder="请输入购买数量" @input="jisuan"/>
				   <van-field v-model="jfprice" label="所需积分" readonly />
			
			</div>
		 
		</van-dialog>
		<Login></Login>
    </div>
</template>

<script>
	import Login from "@/components/Login";
import Vue from "vue";
import { Collapse, CollapseItem,Empty,Dialog,Field } from "vant";
import HeadBar from "@/components/HeadBar";
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Empty);
Vue.use(Dialog);
Vue.use(Field);


export default {
    name: "Question",
    components: {
        HeadBar,
		Login
    },
    data() {
        return {
            title: document.title,
           show:false,
		   num:'',
		   jfprice:0,
		   list:[],
		   zsfjine:0,
		   zgfjine:0,
		   zgfnum:0,
		   price:0
        };
    },
    created() {
		this.getuserdata();
        this.GetData();
    },
    methods: {
		jisuan(num){
			this.jfprice = 	num * this.price;
		},
		tolink(id){
			this.$router.push({
				name:'Shifang',
				query:{
					gid:id
				}
				
			})
		},
		Buy() {
		    var _this = this;
		    _this.$request.post(
		        "api/Gufen/Buy",
		        {
		            token: _this.$utils.getloc("token"),
		            userid: _this.$utils.getloc("userid"),
					uid: _this.$utils.getloc("id"),
					num:_this.num
		        },
		        (res) => {
		           
		           _this.$dialog.alert({
		               title: "提示",
		               message: res.data.msg,
		           });
				   if(res.data.code == 100){
					    _this.GetData();
				   }
				  
		        }
		    );
		},
		getuserdata: function() {
			var _this = this;
			_this.$request.post(
				"api/Gufen/Get", {
					token: _this.$utils.getloc("token"),
					userid: _this.$utils.getloc("userid"),
					uid: _this.$utils.getloc("id"),
				},
				(res) => {
					if (res.data.code == 0) {
						_this.$dialog.alert({
							title: "提示",
							message: res.data.msg,
						});
						return;
					}
					
					//console.log(_this.gufen);
				}
			);
		},
        GetData() {
            var _this = this;
            _this.$request.post(
                "api/Gufen/List",
                {
                    token: _this.$utils.getloc("token"),
                    userid: _this.$utils.getloc("userid"),
					uid: _this.$utils.getloc("id"),
                },
                (res) => {
                    if (res.data.code == 0) {
                        _this.$dialog.alert({
                            title: "提示",
                            message: res.data.msg,
                        });
                        return;
                    }
                    _this.list = res.data.data.slist;
					_this.price = res.data.data.price;
					_this.zsfjine = res.data.data.zsfjine;
					_this.zgfnum = res.data.data.zgfnum;
					_this.zgfjine = res.data.data.zgfjine;
                }
            );
        },
    },
};
</script>

<style scoped>
	
</style>